import { CIcon } from '~/icons/types'

export const ciTaxis: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.575 11.062c-.82-.51-1.85-.6-3.66-.67-.28-.21-.69-.59-.95-.79a8.265 8.265 0 0 0-4.46-2.13l-.49-.95a.494.494 0 0 0-.86-.02l-.52.86c-4.11.01-5.96.26-6.97.71l-.06.03a2.847 2.847 0 0 0-1.17 1.01 3.077 3.077 0 0 1-.76.78l-1.18.35a1.7 1.7 0 0 0-1.13 1.52c-.01.17-.01.34-.02.52v.31a1.523 1.523 0 0 0-.31.95V14.6a1.419 1.419 0 0 0 1.38 1.59h.74c-.02-.15-.03-.3-.03-.45a2.98 2.98 0 1 1 5.96 0c0 .15-.01.3-.03.45h7.08a2.288 2.288 0 0 1-.04-.45 2.985 2.985 0 1 1 5.97 0 2.28 2.28 0 0 1-.04.45h.01c.496-.005.99-.045 1.48-.12.36-.06 1.45-.26 1.45-1.08V13.9a3.1 3.1 0 0 0-1.39-2.84Zm-16.45-.58s-.98-1.45-.98-1.47c.406-.199.842-.33 1.29-.39a28.007 28.007 0 0 1 3.54-.26l.38 2.12h-4.23Zm8.05 3.21h-5.14a.49.49 0 1 1 0-.98h5.14a.49.49 0 1 1 0 .98Zm-2.84-3.21-.36-2.13h.85a8.064 8.064 0 0 1 5.61 2.13h-6.1Z'
    },
    {
      d:
        'M5.105 13.746a1.99 1.99 0 1 0 2 2 2 2 0 0 0-2-2Zm12.975 0a1.991 1.991 0 1 0 2 2 2 2 0 0 0-2-2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'taxis',
  type: 'solid'
}
